export enum NotificationType {
  AsyncData = 'async-data',
  Default = 'Default',
}
